import { analytics } from 'app/utils/segment';
export const klaviyoPartnerTrackingEvents = ({ partnerEvents, }) => {
    partnerEvents.on('klaviyo:profile:unsubscribe:clicked', (payload) => analytics.partnerIntegrationsKlaviyoProfileUnsubscribeClicked(payload));
};
